export default "<!--The content below is only a placeholder and can be replaced.-->\r\n\r\n\r\n<router-outlet></router-outlet>\r\n"